import { Trans } from "react-i18next";

export const ProductDescription = ({ descriptions }: { descriptions: string[] }) => {
  if (!descriptions) return <></>;

  return (
    <div className="d-grid">
      {descriptions.map((description: string, index: number) => (
        <div key={index}>
          <div className="font-18-roman c-646464">
            <Trans i18nKey={description} components={{ strong: <strong /> }} />
          </div>
          <br />
        </div>
      ))}
    </div>
  );
};
